(function () {
  return;
  setTimeout(() => {
    const reviews = [
      ...document.querySelectorAll("[data-yotpo-inline] a.text-m"),
    ];

    console.log(reviews);
    if (reviews.length !== 0) {
      reviews.forEach((review) => {
        const text = review.textContent;
        var num = text.replace(/[^0-9]/g, "");
        review.textContent = `(${num}) Reviews`;
      });
    }
  }, 1000);
})();

(function () {
  setTimeout(() => {
    const productContainers = [...document.querySelectorAll(".product-card")];

    if (productContainers.length !== 0) {
      productContainers.forEach((productContainer) => {
        const imageContainer = productContainer.querySelector(".img.main");
        const customRadios = [
          ...productContainer.querySelectorAll(`[id^="swatch-1-"]`),
        ];
        const customRadios2 = [
          ...productContainer.querySelectorAll(`[id^="swatch-2-"] + label`),
        ];
        const ctaText = productContainer.querySelector(".save-final-price");

        var observer = new MutationObserver(function (mutations) {
          const checkedBtns = [
            ...productContainer.querySelectorAll("[data-custom-radio]:checked"),
          ];
          console.log(checkedBtns);
          const checkedSwatch = checkedBtns[1];
          const swatchSku = checkedSwatch.getAttribute("data-sku");
          const swatchVal = checkedSwatch.value;
          const checkedDub = checkedBtns[0];
          const dubSku = checkedDub.getAttribute("data-sku");
          const dubVal = checkedDub.value;

          console.log(swatchSku);
          console.log(swatchVal);
          console.log(checkedDub);
          console.log(dubSku);
          console.log(dubVal);
          const storageItems = JSON.parse(
            localStorage.getItem("vvvariantProds")
          );

          let item = storageItems.find((c) => c.sku == dubSku);
          if (item) {
            let imgSrc = item["featured_image"].src;
            let imgAlt = item["featured_image"].alt;
            imageContainer.setAttribute("srcset", imgSrc);
            imageContainer.setAttribute("alt", imgAlt);
          }
          console.log(imgSrc);
          console.log(item);
          let itm = storageItems.find(
            (c) => c.name === "Laundry Booster (24 fl. oz.) - Original / 2-Pack"
          );
          console.log("HERE!");
          console.log(itm);

          if (swatchVal === "Original") {
            if (dubVal === "Single") {
            }
            if (dubVal === "2-Pack") {
            }
          } else if (swatchVal === "Lavender") {
            if (dubVal === "Single") {
            }
            if (dubVal === "2-Pack") {
            }
          } else if (swatchVal === "Lemon") {
            if (dubVal === "Single") {
            }
            if (dubVal === "2-Pack") {
            }
          }
          //  console.log(typeof dubVal);
          //  console.log(storageItems);
          //  console.log(item);
          //  console.log(typeof item[0].sku);
          //  const itemname = item.name.split('-')[0];

          // console.log(itemname)
        });

        var config = { childList: true };
        observer.observe(ctaText, config);
        // if (customRadios2.length !== 0)
        //   {
        //     console.log(customRadios2)

        //     customRadios2.forEach(customRadio => {
        //       customRadio.addEventListener('click', e =>{
        //         console.log('pack selector')
        //       })
        //     })
        //   }
        if (customRadios.length !== 0) {
          customRadios.forEach((customRadio) => {
            const imgSrc = customRadio.getAttribute("data-src");
            const imgAlt = customRadio.getAttribute("data-alt");

            customRadio.addEventListener("click", (e) => {
              const sku = customRadio.getAttribute("data-sku");
              const storageItems = JSON.parse(
                localStorage.getItem("vvvariantProds")
              );

              let item = storageItems.find((c) => c.sku === sku);
              //   const itemname = item.name.split("-")[0];
              //  console.log(item);
              if (imageContainer) {
                imageContainer.setAttribute("srcset", imgSrc);
                imageContainer.setAttribute("alt", imgAlt);
              }
            });
          });
        }
      });
    }
  }, 1000);
})();

(function () {
  return;
  const productContainers = [...document.querySelectorAll(".product-card")];
  return;
  if (productContainers.length !== 0) {
    productContainers.forEach((productContainer) => {
      const swatches = productContainer.querySelectorAll(".color-swatches");
      swatches.forEach((swatch) => {
        if (swatch) {
          swatch.classList.add("display-none");
        }
      });
      setTimeout(() => {
        const swatches = productContainer.querySelector(".color-swatches");
        if (swatches) {
          swatches.classList.add("display-block");
        }
      }, 0);
      const saveTextContainer =
        productContainer.querySelectorAll("[data-save]");
      const secondOne = saveTextContainer[1];
    });
  }
})();
// ===================

(function () {
  return;
  const productContainers = [...document.querySelectorAll(".product-card")];

  if (productContainers.length !== 0) {
    productContainers.forEach((productContainer) => {
      const radioContainer = productContainer.querySelector("[data-pack]");

      if (radioContainer) {
        setTimeout(() => {
          const radioBtns = [
            ...radioContainer.querySelectorAll("[data-custom-radio]"),
          ];
          radioBtns.forEach((radioBtn) => {
            const is2Pac = radioBtn.getAttribute("value");
            if (is2Pac === "2-Pack") {
              setTimeout(() => {
                const price = radioBtn.getAttribute("data-price");
                const compare_at_price =
                  radioBtn.getAttribute("data-compare-price");
                const radioId = radioBtn.getAttribute("id");
                const labelElement = productContainer.querySelector(
                  `[for="${radioId}"]`
                );
                const attachToElement =
                  labelElement.querySelector(".pack-value");
                attachToElement.textContent = `2-Pack (Save $${(
                  (compare_at_price - price) /
                  100
                ).toFixed(2)})`;
              }, 0);
            }
          });
        }, 500);
      }
    });
  }
})();
(function () {
  return;
  const productContainer = document.querySelector(".product-card2");
  if (productContainer) {
    const radioContainer = productContainer.querySelector("[data-pack]");

    if (radioContainer) {
      setTimeout(() => {
        const radioBtns = [
          ...radioContainer.querySelectorAll("[data-custom-radio]"),
        ];
        radioBtns.forEach((radioBtn) => {
          const is2Pac = radioBtn.getAttribute("value");

          if (is2Pac === "2-Pack") {
            setTimeout(() => {
              const price = radioBtn.getAttribute("data-price");
              const compare_at_price =
                radioBtn.getAttribute("data-compare-price");
              const radioId = radioBtn.getAttribute("id");
              const labelElement = productContainer.querySelector(
                `[for="${radioId}"]`
              );
              const attachToElement = labelElement.querySelector(".pack-value");
              attachToElement.textContent = `2-Pack (Save $${(
                (compare_at_price - price) /
                100
              ).toFixed(2)})`;
            }, 0);
          }
        });
      }, 500);
    }
  }
})();
